// Shared presentation policy. Server-side authentication remains authoritative.
export const SUPPORT_ROUTES = /^\/(overview|research|search|company(?:\/[^/]+)?|asset(?:\/[^/]+)?|markets(?:\/[^/]+)?|monitor|dealflow|catalysts|ask|settings(?:\/team)?|support|exports|upgrade|watchlist|company-coverage|organization)(?:\/)?$/;
export const DESTINATIONS = Object.freeze({research:'/research', markets:'/markets', monitor:'/monitor', dealflow:'/dealflow', overview:'/overview', catalysts:'/catalysts', support:'/support'});
export function chooseSurface({pathname, authStatus}) {
  if (authStatus === 'loading') return null;
  if (authStatus === 'anonymous') return pathname === '/' ? 'sales' : null;
  if (authStatus === 'authenticated') return SUPPORT_ROUTES.test(pathname) ? 'support' : null;
  return null;
}
export function clientTools({getContext, openAccount, navigate}) {
  return {
    async open_account_action({action}) {
      const c=getContext();
      if(chooseSurface(c)!=='sales' || !['get_started','signin'].includes(action)) return {success:false,code:'ACTION_NOT_ALLOWED'};
      if(typeof openAccount!=='function') return {success:false,code:'ACCOUNT_MODAL_UNAVAILABLE'};
      try { const opened=await openAccount(action); return opened===true ? {success:true,state:'form_opened',account_created:false} : {success:false,code:'ACCOUNT_MODAL_NOT_OPENED'}; }
      catch { return {success:false,code:'ACCOUNT_MODAL_FAILED'}; }
    },
    async open_workspace_destination({destination}) {
      const c=getContext();
      if(chooseSurface(c)!=='support' || !Object.hasOwn(DESTINATIONS,destination)) return {success:false,code:'ACTION_NOT_ALLOWED'};
      if(typeof navigate!=='function') return {success:false,code:'NAVIGATION_UNAVAILABLE'};
      try { await navigate(DESTINATIONS[destination]); return {success:true,state:'navigation_requested',destination:DESTINATIONS[destination],research_started:false}; }
      catch { return {success:false,code:'NAVIGATION_FAILED'}; }
    }
  };
}
